import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PfBudget, PfBudgetAssoc, PfIndicator } from '../../models/apresentacao.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../../services/shared.service';
import { ApresentacaoResolverId } from '../../resolver/apresentacao.resolver';
import { ApresentacaoService } from '../../services/apresentacao.service';
import { Criticals } from '../../models/apresentacao.model';

@Component({
  selector: 'app-apresentacao-slide-modal',
  templateUrl: './apresentacao-slide-modal.component.html',
  styleUrls: ['./apresentacao-slide-modal.component.scss']
})
export class ApresentacaoSlideModalComponent extends BaseFormComponent<PfIndicator> implements OnInit {
  @Input() currentIndicator:PfIndicator = null;
  @Input() currentCritical:Criticals = null;
  @Input() print:boolean = false;
  @Input() meetingId:number = null;
  @Input() titleId:string = '';
  @Input() filters:any;
  @Output() closeModal = new EventEmitter<void>();
  id = null;
  achievementChart = [];
  projectionChart = [];
  patternAchievement = null;
  patternProjection = null;
  currentFilter: any;

  labels={
    'executionProject': 'Execução Orçamentária do Projeto',
    'executionIndicator': 'Execução Orçamentária do Indicador',
    'managerProject': 'Responsáveis',
    'managerIndicator': 'Responsáveis',
    'monitoringDemand': 'Demanda de monitoramento',
    'achievementAndGoal': 'Indicadores',
    'actions': 'Plano de ação'
  }
  constructor(
    public activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
    private myService: ApresentacaoService,
    private apresentacaoResolverId: ApresentacaoResolverId,
  ){
    super(activatedRoute);
  }

  ngOnInit() {
    // console.log(this.currentIndicator)
    this.loaded();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    if(this.titleId == 'monitoringDemand'){
      this.initForm();
    }
    else if(this.titleId == 'achievementAndGoal'){
      this.apresentacaoResolverId.getById( this.id ?? this.meetingId ).subscribe({
        next: (data) => {
          this.entity = data;
          this.currentFilter = data.currentFilter;
          var agencyId = this.currentIndicator?.agency?.num_codigo_pk;
          var currentAchievement = data.graphData.achievementData;
          currentAchievement.agency = currentAchievement.agency.filter(a => a.id == agencyId);
          var currentProjection = data.graphData.projectionData;
          currentProjection.agency = currentProjection.agency.filter(a => a.id == agencyId);
          var achievementData = this.sharedService.filterData2(this.currentFilter, currentAchievement.agency);
          this.achievementChart = this.sharedService.getGraphGoalData(achievementData, this.sharedService.patternAchievement);
          this.patternAchievement = this.sharedService.patternAchievement.map( p => {
              return {...p, 'label': currentAchievement.labels[p.id]['label']};
            }
          );
          var projectionData = this.sharedService.filterData2(this.currentFilter, currentProjection.agency);
          this.projectionChart = this.sharedService.getGraphGoalData(projectionData, this.sharedService.patternProjection);
          this.patternProjection = this.sharedService.patternProjection.map( p => {
              return {...p, 'label': currentProjection.labels[p.id]['label']};
            }
          );
        }
      })
    }
  }

  initForm() {
    this.form = new FormGroup({
      meeting_id: new FormControl( this.id ?? this.meetingId),
      agency_id: new FormControl( this.currentIndicator?.agency?.num_codigo_pk),
      pf_indicator_id: new FormControl(this.currentIndicator?.id),
      subject: new FormControl(null, Validators.required),
      description: new FormControl(null),
      pf_ind_manager_main: new FormControl(null),
      pf_ind_manager_not_main: this.createDataFormArray('pf_ind_manager_not_main'),
      issue_stat_id: new FormControl(1),
      dt_foreseen_end: new FormControl(null, Validators.required),
    });
    /*
    if (this.currentIndicator) {
      this.form.patchValue(this.currentIndicator);
      var person = this.currentIndicator?.pf_ind_manager_main?.tb_pss_pessoa;
      this.form.get('pf_ind_manager_main').setValue(person?.str_cpf_pk || null);
    }*/
  }

  compareCPF(item1: any, item2: any): boolean {
    if (!item1 || !item2) {
      return false;
    }
    return item1 === item2.str_cpf_pk || item1.id === item2.str_cpf_pk;
  }
  

  createDataFormArray(field:string){
    if (!this.currentIndicator || !this.currentIndicator[field]) {
      return new FormArray([new FormControl(null)]);
    }
    return new FormArray(
      this.currentIndicator[field]?.map(ind => 
        new FormControl(ind?.tb_pss_pessoa?.str_cpf_pk || null)
      )
    );
  }

  onCloseModal(){
    this.closeModal.emit();
  }

  getFormArray(field:string): FormArray {
    return this.form.get(field) as FormArray;
  }

  addItem(field:string){
    this.getFormArray(field).push(new FormControl(null));
  }

  removeItem(field:string, index:number){
    this.getFormArray(field).removeAt(index);
  }

  getPlanned(item:PfBudget){
    var result = 0;
    item?.pf_exec_budget_table?.forEach(p => {
      if(item?.year === p?.year)
        result = p?.replanned ??  p?.planned;
        return;
    })
    return result ?? 0;
  }

  getLoa(item:PfBudget){
    var value = 0;
    var year = item?.year;
    item?.pf_budget_assoc?.forEach(b => {
      if(b?.pf_budget_fpe?.length>0){
        b?.pf_budget_fpe?.forEach(f =>{
          if(f?.subprojeto == '000000'){
            var t17 = f?.tb_fpe_t17_execucao_orcamentaria_mensal;
            t17.forEach(t=>{
              if(t.num_val_dotacao_alteracao >0 && t.exercicio == year.toString()){
                value = +t.num_val_dotacao_alteracao;
                return;
              }
            })
          }
          else{
            var t552 = f?.tb_fpe_t552_mensal;
            t552.forEach(t=>{
              if(t.num_val_dotacao_alteracao >0 && t.exercicio == year.toString()){
                value = +t.num_val_dotacao_alteracao;
                return;
              }
            })
          }
        });
      }
    });
    return value ?? 0;
  }

  getData(item,key,manualKey){
    if (item?.pf_budget_plan_last){
      if( item?.budget_type == this.filters?.typeFpe){
        return item?.pf_budget_plan_last[key] ?? 0;
      } 
      else{
        return item[manualKey] ?? 0;
      }
    }
    return 0
  }

  orderData(data){
    return data?.sort((a,b) => a?.ano_exercicio - b?.ano_exercicio);
  }
  orderData2(data){
    return data?.sort((a,b) => a?.execucao_orcamentaria?.ano_exercicio - b?.execucao_orcamentaria?.ano_exercicio);
  }

  onKeydownEnter(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    if (target.tagName === 'TEXTAREA') {
      return;
    }
    event.preventDefault();
  }

  getDataCreate() {
    return Object.assign({}, this.form.value);
  }

  salvar(): void {
    this.loading();
    if (this.form.valid) {
      var newData = this.getDataCreate();
      this.myService.createDemand(newData).subscribe({
        next: (res) => {
          this.form.markAsPristine();
          this.confirmation("Demanda criada com sucesso!").subscribe(() => {
            window.location.reload();                
          })
          this.loaded();
        },
        error: (error) => {
          this.msgError(error.error.message);
          this.loaded();
        },
      });
    }
    else {
      this.markAsDirty();
      this.loaded();
    }
  }
  
  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }
}
